import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import type { ChangeSalesRep, RaiseSalesReturnRequest, voidInvoiceRequest } from '@fitness-force/models';
import { CONST_URL_SEGEMENTS } from '@fitness-force/constants';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AppErrors, BadRequestError, NotFoundError } from '@fitness-force/models';;
import { environment } from '@fitness-force/environments';
import { NotificationChannels } from '@fitness-force/enum';


@Injectable({
  providedIn: 'root'
})
export class InvoiceService {
  private http = inject(HttpClient);


  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    })
  };

  getClientInvoices(clientId: any): Observable<any> {
    return this.http.get(`${environment.BASE_URL}${CONST_URL_SEGEMENTS.CLIENT.GET_CLIENTS}/${clientId}${CONST_URL_SEGEMENTS.CLIENT.INVOICES}`, {
      headers: this.httpOptions.headers
    }).pipe(
      map((res: any) => {
        if (res) {
          return res
        }
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  getInvoice(clientId: number, invoiceId:number): Observable<any> {
    return this.http.get(`${environment.BASE_URL}${CONST_URL_SEGEMENTS.CLIENT.GET_CLIENTS}/${clientId}${CONST_URL_SEGEMENTS.CLIENT.INVOICES}/${invoiceId}`, {
      headers: this.httpOptions.headers
    }).pipe(
      map((res: any) => {
        if (res) {
          return res
        }
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  getInvoicePDF(clientId: number, invoiceId:number): Observable<any> {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.INVOICES.GET_INVOICE_PDF.replace('{client_id}', clientId.toString()).replace('{invoice_id}', invoiceId.toString());
    return this.http.get(url).pipe(
      map((res: any) => {
          return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  voidInvoice(tenantId:number,clientId: number, invoiceId:number, voidRequest: voidInvoiceRequest): Observable<any> {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.INVOICES.VOID_INVOICE.replace('{tenant_id}', tenantId.toString()).replace('{client_id}', clientId.toString()).replace('{invoice_id}', invoiceId.toString());
    return this.http.post(url, voidRequest, {headers: this.httpOptions.headers}).pipe(
      map((res: any) => {
        if (res) {
          return res
        }
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  SendInvoicePDF(clientId: number, invoiceId:number, channels:any[]): Observable<any> {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.INVOICES.SEND_EMAIL.replace('{client_id}', clientId.toString()).replace('{invoice_id}', invoiceId.toString());
    return this.http.post(url, channels,{
      headers: this.httpOptions.headers
    }).pipe(
      map((res: any) => {
          return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  SalesReturn(tenantId:number,clientId: number, invoiceId:number, raiseSalesReturnRequest:RaiseSalesReturnRequest): Observable<any> {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.INVOICES.SALES_RETURN.replace('{tenant_id}', tenantId.toString()).replace('{client_id}', clientId.toString()).replace('{invoice_id}', invoiceId.toString());
    return this.http.get(url, {
      headers: this.httpOptions.headers
    }).pipe(
      map((res: any) => {
        if (res) {
          return res
        }
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  getOpenInvoicePDF(uuid:string): Observable<string> {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.INVOICES.GET_INVOICE_OPEN.replace('{uuid}', uuid);
    return this.http.get(url).pipe(
      map((res: any) => {
          return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  ChangeSalesRep(tenantId:number,clientId: number, invoiceId:number, changeSalesrep:ChangeSalesRep): Observable<any> {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.INVOICES.CHANGE_SALES_REP.replace('{tenant_id}', tenantId.toString()).replace('{client_id}', clientId.toString()).replace('{invoice_id}', invoiceId.toString());
    return this.http.post(url, changeSalesrep, {
      headers: this.httpOptions.headers
    }).pipe(
      map((res: any) => {
          return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  InvoiceDueSendManageLink(tenant_id: number, clientId: number, invoiceId: number, channels: NotificationChannels[]) {
    return this.http.post(environment.BASE_URL + CONST_URL_SEGEMENTS.INVOICE_ADDITIONAL.SEND_INVOICE_CLEAR_BALANCE_LINK
      .replace('{tenant_id}', tenant_id.toString())
      .replace('{client_id}', clientId.toString())
      .replace('{invoice_id}', invoiceId.toString())
      , channels
      , this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  RetryFailedPayment(tenantId: number, clientId: number, invoiceId: number) {
    return this.http.post(environment.BASE_URL + CONST_URL_SEGEMENTS.INVOICES.CHARGE_MANUAL_FAILED_PAYMENTS
      .replace('{tenant_id}', tenantId.toString())
      .replace('{client_id}', clientId.toString())
      .replace('{invoice_id}', invoiceId.toString())
      , this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  WriteOffInvoice(tenantId: number, clientId: number, invoiceId: number, payload:any) {
    return this.http.post(environment.BASE_URL + CONST_URL_SEGEMENTS.INVOICES.CREATE_WRITEOFF
      .replace('{tenant_id}', tenantId.toString())
      .replace('{client_id}', clientId.toString())
      .replace('{invoice_id}', invoiceId.toString()), payload,
      this.httpOptions)
      .pipe(
        map((res: any) => {
          return res; 
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          } else if (error.status === 400) {
            return throwError(() => new BadRequestError(error))
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  getWriteOffs(tenantId: number, clientId: number, invoiceId: number): Observable<any[]> {
    return this.http.get(environment.BASE_URL + CONST_URL_SEGEMENTS.INVOICES.GET_WRITEOFF
      .replace('{tenant_id}', tenantId.toString())
      .replace('{client_id}', clientId.toString())
      .replace('{invoice_id}', invoiceId.toString()),
      this.httpOptions)
      .pipe(
        map((res: any) => {
          return res; 
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          } else if (error.status === 400) {
            return throwError(() => new BadRequestError(error))
          }
          return throwError(() => new AppErrors(error));
        })
      );
    
    }

 

  voidWriteOff(tenantId: number, clientId: number, invoiceId: number, writeOffId: number, payload: any): Observable<any> {
    return this.http.post(environment.BASE_URL + CONST_URL_SEGEMENTS.INVOICES.VOID_WRITEOFF
      .replace('{tenant_id}', tenantId.toString())
      .replace('{client_id}', clientId.toString())
      .replace('{invoice_id}', invoiceId.toString())
      .replace('{writeoff_id}', writeOffId.toString()),
      payload,
      this.httpOptions)
      .pipe(
        map((res: any) => {
          return res; 
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          } else if (error.status === 400) {
            return throwError(() => new BadRequestError(error))
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }
}
